<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs">
     CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ba" title="Informasi keselamatan">
     Informasi keselamatan
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvensi">
      Konvensi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="Pernyataan produk">
      Pernyataan produk
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ba" title="Pelajari tentang printer">
     Pelajari tentang printer
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ba" title="Mencari informasi tentang printer">
      Mencari informasi tentang printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ba" title="Mencari nomor seri printer">
      Mencari nomor seri printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ba" title="Konfigurasi printer">
      Konfigurasi printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ba" title="Menggunakan panel kontrol">
      Menggunakan panel kontrol
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_ba" title="Ikon layar awal">
      Ikon layar awal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_ba" title="Warna lampu indikator">
      Warna lampu indikator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ba" title="Menggunakan pengumpan dokumen otomatis dan kaca pemindai">
      Menggunakan pengumpan dokumen otomatis dan kaca pemindai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ba" title="Mencari slot keamanan">
      Mencari slot keamanan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="Memilih kertas">
      Memilih kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10635" title="Dukungan dan fitur tambahan printer">
      Dukungan dan fitur tambahan printer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ba" title="Menyiapkan, menginstal, dan mengatur">
     Menyiapkan, menginstal, dan mengatur
    </a>
   </p>
   <div id="divd0e10762">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_ba" title="Memilih lokasi printer">
      Memilih lokasi printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_ba" title="Port printer">
      Port printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10961" title="Mengatur aplikasi dan solusi">
      Mengatur aplikasi dan solusi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11138" title="Menyiapkan dan menggunakan fitur aksesibilitas">
      Menyiapkan dan menggunakan fitur aksesibilitas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11443" title="Menyiapkan printer untuk mengirim/menerima faks">
      Menyiapkan printer untuk mengirim/menerima faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_ba" title="Memasukkan kertas dan media khusus">
      Memasukkan kertas dan media khusus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12239" title="Menginstal dan memperbarui perangkat lunak, driver, dan firmware">
      Menginstal dan memperbarui perangkat lunak, driver, dan firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12565" title="Menginstal opsi perangkat keras">
      Menginstal opsi perangkat keras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14096" title="Jaringan">
      Jaringan
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ba" title="Mengamankan printer">
     Mengamankan printer
    </a>
   </p>
   <div id="divd0e14448">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ba" title="Menghapus memori printer">
      Menghapus memori printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ba" title="Menghapus drive penyimpanan printer">
      Menghapus drive penyimpanan printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ba" title="Memulihkan ke setelan default pabrik">
      Memulihkan ke setelan default pabrik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ba" title="Pernyataan Volatilitas">
      Pernyataan Volatilitas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ba" title="Cetak">
     Cetak
    </a>
   </p>
   <div id="divd0e14640">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_ba" title="Mencetak dari komputer">
      Mencetak dari komputer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691" title="Mencetak dari perangkat seluler">
      Mencetak dari perangkat seluler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ba" title="Mencetak dari flash drive">
      Mencetak dari flash drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ba" title="Mengonfigurasi pekerjaan rahasia">
      Mengonfigurasi pekerjaan rahasia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ba" title="Mencetak dokumen rahasia dan pekerjaan tertunda">
      Mencetak dokumen rahasia dan pekerjaan tertunda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_ba" title="Mencetak daftar sampel font">
      Mencetak daftar sampel font
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_ba" title="Mencetak daftar direktori">
      Mencetak daftar direktori
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ba" title="Menempatkan lembaran pemisah di pekerjaan cetak">
      Menempatkan lembaran pemisah di pekerjaan cetak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ba" title="Membatalkan pekerjaan cetak">
      Membatalkan pekerjaan cetak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ba" title="Menyesuaikan kegelapan toner">
      Menyesuaikan kegelapan toner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ba" title="Salin">
     Salin
    </a>
   </p>
   <div id="divd0e15186">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ba" title="Membuat salinan">
      Membuat salinan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ba" title="Menyalin foto">
      Menyalin foto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_ba" title="Menyalin di letterhead">
      Menyalin di letterhead
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ba" title="Menyalin pada dua sisi kertas">
      Menyalin pada dua sisi kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ba" title="Mengecilkan atau membesarkan salinan">
      Mengecilkan atau membesarkan salinan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ba" title="Menyusun salinan">
      Menyusun salinan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ba" title="Menempatkan lembaran pemisah di antara salinan">
      Menempatkan lembaran pemisah di antara salinan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ba" title="Menyalin beberapa halaman di satu lembar kertas">
      Menyalin beberapa halaman di satu lembar kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ba" title="Menyalin kartu">
      Menyalin kartu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ba" title="Membuat pintasan salin">
      Membuat pintasan salin
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_ba" title="Email">
     Email
    </a>
   </p>
   <div id="divd0e15459">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_ba" title="Mengatur setelan SMTP">
      Mengatur setelan SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ba" title="Mengirim email">
      Mengirim email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ba" title="Membuat pintasan email">
      Membuat pintasan email
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ba" title="Faks">
     Faks
    </a>
   </p>
   <div id="divd0e16908">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ba" title="Mengirim faks">
      Mengirim faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_ba" title="Menjadwalkan faks">
      Menjadwalkan faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ba" title="Membuat pintasan destinasi faks">
      Membuat pintasan destinasi faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ba" title="Mengganti resolusi faks">
      Mengganti resolusi faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ba" title="Menyesuaikan kegelapan faks">
      Menyesuaikan kegelapan faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ba" title="Mencetak log faks">
      Mencetak log faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ba" title="Memblokir faks sampah">
      Memblokir faks sampah
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ba" title="Holding faxes (Menunda faks)">
      Holding faxes (Menunda faks)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ba" title="Meneruskan faks">
      Meneruskan faks
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ba" title="Pindai">
     Pindai
    </a>
   </p>
   <div id="divd0e17204">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ba" title="Memindai ke komputer">
      Memindai ke komputer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ba" title="Memindai ke server FTP">
      Memindai ke server FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ba" title="Membuat pintasan FTP">
      Membuat pintasan FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_ba" title="Memindai ke folder jaringan">
      Memindai ke folder jaringan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ba" title="Mengatur destinasi folder jaringan">
      Mengatur destinasi folder jaringan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ba" title="Membuat pintasan folder jaringan">
      Membuat pintasan folder jaringan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ba" title="Memindai ke flash drive">
      Memindai ke flash drive
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_ba" title="menu printer">
     menu printer
    </a>
   </p>
   <div id="divd0e17493">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_ba" title="Peta menu">
      Peta menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17807" title="Perangkat">
      Perangkat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20041" title="Cetak">
      Cetak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21323" title="Kertas">
      Kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21655" title="Salin">
      Salin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22214" title="Faks">
      Faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24081" title="Email">
      Email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25178" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25884" title="USB Drive">
      USB Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26730" title="Port/Jaringan">
      Port/Jaringan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28881" title="Keamanan">
      Keamanan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29978" title="Layanan Cloud">
      Layanan Cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30035" title="Laporan">
      Laporan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ba" title="Troubleshooting (Pemecahan Masalah)">
      <strong>
       Troubleshooting (Pemecahan Masalah)
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_ba" title="Forms Merge (Gabung Formulir)">
      <strong>
       Forms Merge (Gabung Formulir)
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ba" title="Mencetak Menu Settings Page (Halaman Setelan Menu)">
      Mencetak
      <strong>
       Menu Settings Page (Halaman Setelan Menu)
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ba" title="Opsi lis printer">
     Opsi lis printer
    </a>
   </p>
   <div id="divd0e30518">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_ba" title="Menggunakan lis stapler">
      Menggunakan lis stapler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ba" title="Menggunakan lis lubang stapler">
      Menggunakan lis lubang stapler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_ba" title="Menggunakan penumpuk ofset">
      Menggunakan penumpuk ofset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_ba" title="Menggunakan lis buklet">
      Menggunakan lis buklet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_ba" title="Menggunakan penyalur kertas dengan opsi lipatan">
      Menggunakan penyalur kertas dengan opsi lipatan
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ba" title="Merawat printer">
     Merawat printer
    </a>
   </p>
   <div id="divd0e30928">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_ba" title="Memeriksa status bahan pakai dan suku cadang">
      Memeriksa status bahan pakai dan suku cadang
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ba" title="Mengatur notifikasi bahan pakai">
      Mengatur notifikasi bahan pakai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_ba" title="Menyiapkan peringatan email">
      Menyiapkan peringatan email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_ba" title="Membuat laporan dan log">
      Membuat laporan dan log
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ba" title="Memesan bahan pakai dan suku cadang">
      Memesan bahan pakai dan suku cadang
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31783" title="Mengganti bahan pakai dan suku cadang">
      Mengganti bahan pakai dan suku cadang
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32407" title="Membersihkan bagian printer">
      Membersihkan bagian printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32571" title="Menghemat energi dan kertas">
      Menghemat energi dan kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ba" title="Memindah printer ke lokasi lain">
      Memindah printer ke lokasi lain
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ba" title="Menyelesaikan masalah">
     Menyelesaikan masalah
    </a>
   </p>
   <div id="divd0e32709">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ba" title="Masalah kualitas cetak">
      Masalah kualitas cetak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_ba" title="Kode eror printer">
      Kode eror printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ba" title="Masalah mencetak">
      Masalah mencetak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ba" title="Printer tidak merespons">
      Printer tidak merespons
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ba" title="Tidak bisa membaca dari flash drive">
      Tidak bisa membaca dari flash drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ba" title="Mengaktifkan port USB">
      Mengaktifkan port USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ba" title="Mengatasi kertas macet">
      Mengatasi kertas macet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36133" title="Masalah koneksi jaringan">
      Masalah koneksi jaringan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36226" title="Masalah opsi perangkat keras">
      Masalah opsi perangkat keras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399" title="Masalah dengan bahan pakai">
      Masalah dengan bahan pakai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36547" title="Masalah pengumpanan kertas">
      Masalah pengumpanan kertas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36741" title="Mengirim masalah via email">
      Mengirim masalah via email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36796" title="masalah faks">
      masalah faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37118" title="Masalah memindai">
      Masalah memindai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37536" title="Masalah kualitas warna">
      Masalah kualitas warna
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ba" title="Menghubungi dukungan pelanggan">
      Menghubungi dukungan pelanggan
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ba" title="Membuang dan mendaur ulang">
     Membuang dan mendaur ulang
    </a>
   </p>
   <div id="divd0e37762">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ba" title="Mendaur ulang produk Lexmark">
      Mendaur ulang produk Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ba" title="Mendaur ulang kemasan Lexmark">
      Mendaur ulang kemasan Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ba" title="Pemberitahuan">
     Pemberitahuan
    </a>
   </p>
   <div id="divd0e37798">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37801" title="Informasi produk">
      Informasi produk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37818" title="Pemberitahuan edisi">
      Pemberitahuan edisi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ba" title="Merek Dagang">
      Merek Dagang
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ba" title="Pemberitahuan tentang lisensi">
      Pemberitahuan tentang lisensi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ba" title="Tingkat emisi suara">
      Tingkat emisi suara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37916" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ba" title="Pembuangan produk">
      Pembuangan produk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ba" title="Pemberitahuan sensitivitas statik">
      Pemberitahuan sensitivitas statik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ba" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ba" title="Informasi suhu">
      Informasi suhu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ba" title="Pemberitahuan Laser">
      Pemberitahuan Laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ba" title="Konsumsi daya">
      Konsumsi daya
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38159" title="Pemberitahuan tentang peraturan untuk produk nirkabel">
      Pemberitahuan tentang peraturan untuk produk nirkabel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ba" title="Pemberitahuan komponen modular">
      Pemberitahuan komponen modular
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ba" title="Pemaparan terhadap radiasi frekuensi radio">
      Pemaparan terhadap radiasi frekuensi radio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ba" title="Pemberitahuan mengenai interferensi radio">
      Pemberitahuan mengenai interferensi radio
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue